import {
  ADD_PRODUCT_TO_ERP_FAILURE,
  ADD_PRODUCT_TO_ERP_REQUEST,
  ADD_PRODUCT_TO_ERP_SUCCESS,
  BROWSE_PRICE_FILE_FAILURE,
  // Price File (browser)
  BROWSE_PRICE_FILE_REQUEST,
  BROWSE_PRICE_FILE_RESET,
  BROWSE_PRICE_FILE_SUCCESS,
  SEARCH_DESCRIPTION_MATCH_FAILURE,
  SEARCH_DESCRIPTION_MATCH_REQUEST,
  SEARCH_DESCRIPTION_MATCH_RESET,
  SEARCH_DESCRIPTION_MATCH_SUCCESS,
  SEARCH_ITEM_ID_FAILURE,
  // Item ID
  SEARCH_ITEM_ID_REQUEST,
  SEARCH_ITEM_ID_RESET,
  SEARCH_ITEM_ID_SUCCESS,
  SEARCH_MFG_PRICING_GROUP_FAILURE,
  //mfg Pricing
  SEARCH_MFG_PRICING_GROUP_REQUEST,
  SEARCH_MFG_PRICING_GROUP_RESET,
  SEARCH_MFG_PRICING_GROUP_SUCCESS,
  SEARCH_PRICE_FILE_FAILURE,
  // Price File (inline search)
  SEARCH_PRICE_FILE_REQUEST,
  SEARCH_PRICE_FILE_RESET,
  SEARCH_PRICE_FILE_SUCCESS,
  SEARCH_PRODUCT_CLASS_FAILURE,
  // Product Class
  SEARCH_PRODUCT_CLASS_REQUEST,
  SEARCH_PRODUCT_CLASS_RESET,
  SEARCH_PRODUCT_CLASS_SUCCESS,
  SEARCH_PRODUCT_DISCOUNT_GROUP_FAILURE,
  // Product Discount Group
  SEARCH_PRODUCT_DISCOUNT_GROUP_REQUEST,
  SEARCH_PRODUCT_DISCOUNT_GROUP_RESET,
  SEARCH_PRODUCT_DISCOUNT_GROUP_SUCCESS,
  SEARCH_PRODUCT_GROUP_FAILURE,
  // Product Group
  SEARCH_PRODUCT_GROUP_REQUEST,
  SEARCH_PRODUCT_GROUP_RESET,
  SEARCH_PRODUCT_GROUP_SUCCESS,
  SEARCH_SUPPLIER_FAILURE,
  // Supplier
  SEARCH_SUPPLIER_REQUEST,
  SEARCH_SUPPLIER_RESET,
  SEARCH_SUPPLIER_SUCCESS,
  SEARCH_UOM_FAILURE,
  // UOM
  SEARCH_UOM_REQUEST,
  SEARCH_UOM_RESET,
  SEARCH_UOM_SUCCESS,
  SEARCH_VENDOR_PORTAL_CANCEL,
  SEARCH_VENDOR_PORTAL_FAILURE,
  // Vendor Portal
  SEARCH_VENDOR_PORTAL_REQUEST,
  SEARCH_VENDOR_PORTAL_RESET,
  SEARCH_VENDOR_PORTAL_SUCCESS,
  SEARCH_VENDOR_SITE_FAILURE,
  SEARCH_VENDOR_SITE_REQUEST,
  SEARCH_VENDOR_SITE_RESET,
  SEARCH_VENDOR_SITE_SUCCESS
} from '@/constants/addERPProductConstants'

const initialState = {
  // Item ID State
  itemId: {
    loading: false,
    data: null,
    error: null
  },
  // Description Match Search State
  descriptionMatch: {
    loading: false,
    data: null,
    error: null
  },
  // Product Class State
  productClass: {
    loading: false,
    data: null,
    error: null
  },
  // Product Discount Group State
  productDiscountGroup: {
    loading: false,
    data: null,
    error: null
  },
  // Product Group State
  productGroup: {
    loading: false,
    data: null,
    error: null
  },
  // Mfg pricing Group State
  mfgPricingGroup: {
    loading: false,
    data: null,
    error: null
  },
  // UOM State
  uom: {
    loading: false,
    data: null,
    error: null
  },
  // Supplier State
  supplier: {
    loading: false,
    data: null,
    error: null
  },
  // Submit State
  submit: {
    loading: false,
    data: null,
    error: null
  },
  // Price File inline search (small results panel under Item ID tab)
  priceFile: {
    loading: false,
    items: [],
    page: 1,
    page_size: 10,
    has_next: false,
    next_page: null,
    total: 0,
    error: null
  },
  // Price File full browser (paginated DataTable)
  priceFileBrowse: {
    loading: false,
    items: [],
    page: 1,
    page_size: 25,
    has_next: false,
    next_page: null,
    total: 0,
    priceFileId: null,
    error: null
  },
  // Vendor Portal slow search
  vendorPortal: {
    loading: false,
    items: [],
    error: null,
    startedAt: null,
    expectedMs: 45000,
    cancelled: false
  },
  // Vendor Site search
  vendorSite: {
    loading: false,
    data: null,
    error: null
  }
}

// Helper to build request state for paginated search
const paginatedRequestState = (currentState, action) => ({
  ...currentState,
  loading: action.page === 1,
  loadingMore: action.page > 1,
  error: null
})

// Helper to build success state for paginated search (appends items when page > 1)
const paginatedSuccessState = (currentState, action) => {
  const isAppend = action.page > 1 && currentState.data?.items
  return {
    loading: false,
    loadingMore: false,
    data: isAppend ? { ...action.payload, items: [...currentState.data.items, ...action.payload.items] } : action.payload,
    error: null
  }
}

const addERPProductReducer = (state = initialState, action) => {
  switch (action.type) {
    // ============================================
    // Item ID Cases
    // ============================================
    case SEARCH_ITEM_ID_REQUEST:
      return {
        ...state,
        itemId: {
          ...state.itemId,
          loading: true,
          error: null
        }
      }
    case SEARCH_ITEM_ID_SUCCESS:
      return {
        ...state,
        itemId: {
          loading: false,
          data: action.payload,
          error: null
        }
      }
    case SEARCH_ITEM_ID_FAILURE:
      return {
        ...state,
        itemId: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_ITEM_ID_RESET:
      return {
        ...state,
        itemId: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Description Match Cases
    // ============================================
    case SEARCH_DESCRIPTION_MATCH_REQUEST:
      return {
        ...state,
        descriptionMatch: {
          ...state.descriptionMatch,
          loading: true,
          error: null
        }
      }
    case SEARCH_DESCRIPTION_MATCH_SUCCESS:
      return {
        ...state,
        descriptionMatch: {
          loading: false,
          data: action.payload,
          error: null
        }
      }
    case SEARCH_DESCRIPTION_MATCH_FAILURE:
      return {
        ...state,
        descriptionMatch: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_DESCRIPTION_MATCH_RESET:
      return {
        ...state,
        descriptionMatch: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Product Class Cases
    // ============================================
    case SEARCH_PRODUCT_CLASS_REQUEST:
      return {
        ...state,
        productClass: paginatedRequestState(state.productClass, action)
      }
    case SEARCH_PRODUCT_CLASS_SUCCESS:
      return {
        ...state,
        productClass: paginatedSuccessState(state.productClass, action)
      }
    case SEARCH_PRODUCT_CLASS_FAILURE:
      return {
        ...state,
        productClass: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_PRODUCT_CLASS_RESET:
      return {
        ...state,
        productClass: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Product Discount Group Cases
    // ============================================
    case SEARCH_PRODUCT_DISCOUNT_GROUP_REQUEST:
      return {
        ...state,
        productDiscountGroup: paginatedRequestState(state.productDiscountGroup, action)
      }
    case SEARCH_PRODUCT_DISCOUNT_GROUP_SUCCESS:
      return {
        ...state,
        productDiscountGroup: paginatedSuccessState(state.productDiscountGroup, action)
      }
    case SEARCH_PRODUCT_DISCOUNT_GROUP_FAILURE:
      return {
        ...state,
        productDiscountGroup: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_PRODUCT_DISCOUNT_GROUP_RESET:
      return {
        ...state,
        productDiscountGroup: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Product Group Cases
    // ============================================
    case SEARCH_PRODUCT_GROUP_REQUEST:
      return {
        ...state,
        productGroup: paginatedRequestState(state.productGroup, action)
      }
    case SEARCH_PRODUCT_GROUP_SUCCESS:
      return {
        ...state,
        productGroup: paginatedSuccessState(state.productGroup, action)
      }
    case SEARCH_PRODUCT_GROUP_FAILURE:
      return {
        ...state,
        productGroup: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_PRODUCT_GROUP_RESET:
      return {
        ...state,
        productGroup: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Mfg Pricing Group Cases
    // ============================================
    case SEARCH_MFG_PRICING_GROUP_REQUEST:
      return {
        ...state,
        mfgPricingGroup: paginatedRequestState(state.mfgPricingGroup, action)
      }

    case SEARCH_MFG_PRICING_GROUP_SUCCESS:
      return {
        ...state,
        mfgPricingGroup: paginatedSuccessState(state.mfgPricingGroup, action)
      }

    case SEARCH_MFG_PRICING_GROUP_FAILURE:
      return {
        ...state,
        mfgPricingGroup: {
          loading: false,
          loadingMore: false,
          data: null,
          error: action.payload
        }
      }

    case SEARCH_MFG_PRICING_GROUP_RESET:
      return {
        ...state,
        mfgPricingGroup: {
          loading: false,
          loadingMore: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // UOM Cases
    // ============================================
    case SEARCH_UOM_REQUEST:
      return {
        ...state,
        uom: paginatedRequestState(state.uom, action)
      }
    case SEARCH_UOM_SUCCESS:
      return {
        ...state,
        uom: paginatedSuccessState(state.uom, action)
      }
    case SEARCH_UOM_FAILURE:
      return {
        ...state,
        uom: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_UOM_RESET:
      return {
        ...state,
        uom: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Supplier Cases
    // ============================================
    case SEARCH_SUPPLIER_REQUEST:
      return {
        ...state,
        supplier: paginatedRequestState(state.supplier, action)
      }
    case SEARCH_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplier: paginatedSuccessState(state.supplier, action)
      }
    case SEARCH_SUPPLIER_FAILURE:
      return {
        ...state,
        supplier: {
          loading: false,
          data: null,
          error: action.payload
        }
      }
    case SEARCH_SUPPLIER_RESET:
      return {
        ...state,
        supplier: {
          loading: false,
          data: null,
          error: null
        }
      }

    // ============================================
    // Add Product to ERP Cases
    // ============================================
    case ADD_PRODUCT_TO_ERP_REQUEST:
      return {
        ...state,
        submit: {
          loading: true,
          data: null,
          error: null
        }
      }
    case ADD_PRODUCT_TO_ERP_SUCCESS:
      return {
        ...state,
        submit: {
          loading: false,
          data: action.payload,
          error: null
        }
      }
    case ADD_PRODUCT_TO_ERP_FAILURE:
      return {
        ...state,
        submit: {
          loading: false,
          data: null,
          error: action.payload
        }
      }

    // ============================================
    // Price File Inline Search Cases
    // ============================================
    case SEARCH_PRICE_FILE_REQUEST:
      return {
        ...state,
        priceFile: {
          ...state.priceFile,
          loading: true,
          error: null
        }
      }
    case SEARCH_PRICE_FILE_SUCCESS:
      return {
        ...state,
        priceFile: {
          loading: false,
          items: action.payload.items || [],
          page: Number(action.payload.page) || 1,
          page_size: Number(action.payload.page_size) || 10,
          has_next: !!action.payload.has_next,
          next_page: action.payload.next_page ?? null,
          total: action.payload.total ?? 0,
          error: null
        }
      }
    case SEARCH_PRICE_FILE_FAILURE:
      return {
        ...state,
        priceFile: {
          ...state.priceFile,
          loading: false,
          error: action.payload
        }
      }
    case SEARCH_PRICE_FILE_RESET:
      return {
        ...state,
        priceFile: {
          loading: false,
          items: [],
          page: 1,
          page_size: 10,
          has_next: false,
          next_page: null,
          total: 0,
          error: null
        }
      }

    // ============================================
    // Price File Browser Cases
    // ============================================
    case BROWSE_PRICE_FILE_REQUEST:
      return {
        ...state,
        priceFileBrowse: {
          ...state.priceFileBrowse,
          loading: true,
          priceFileId: action.priceFileId,
          error: null
        }
      }
    case BROWSE_PRICE_FILE_SUCCESS: {
      const incoming = action.payload.items || []
      const existing = state.priceFileBrowse.items || []
      return {
        ...state,
        priceFileBrowse: {
          loading: false,
          items: action.append ? [...existing, ...incoming] : incoming,
          page: Number(action.payload.page) || 1,
          page_size: Number(action.payload.page_size) || 25,
          has_next: !!action.payload.has_next,
          next_page: action.payload.next_page ?? null,
          total: action.payload.total ?? 0,
          priceFileId: action.priceFileId,
          error: null
        }
      }
    }
    case BROWSE_PRICE_FILE_FAILURE:
      return {
        ...state,
        priceFileBrowse: {
          ...state.priceFileBrowse,
          loading: false,
          error: action.payload
        }
      }
    case BROWSE_PRICE_FILE_RESET:
      return {
        ...state,
        priceFileBrowse: {
          loading: false,
          items: [],
          page: 1,
          page_size: 25,
          has_next: false,
          next_page: null,
          total: 0,
          priceFileId: null,
          error: null
        }
      }

    // ============================================
    // Vendor Portal Cases
    // ============================================
    case SEARCH_VENDOR_PORTAL_REQUEST:
      return {
        ...state,
        vendorPortal: {
          loading: true,
          items: [],
          error: null,
          startedAt: action.startedAt,
          expectedMs: action.expectedMs,
          cancelled: false
        }
      }
    case SEARCH_VENDOR_PORTAL_SUCCESS:
      return {
        ...state,
        vendorPortal: {
          ...state.vendorPortal,
          loading: false,
          items: action.payload.items || [],
          error: null
        }
      }
    case SEARCH_VENDOR_PORTAL_FAILURE:
      return {
        ...state,
        vendorPortal: {
          ...state.vendorPortal,
          loading: false,
          error: action.payload
        }
      }
    case SEARCH_VENDOR_PORTAL_CANCEL:
      return {
        ...state,
        vendorPortal: {
          ...state.vendorPortal,
          loading: false,
          cancelled: true,
          error: null
        }
      }
    case SEARCH_VENDOR_PORTAL_RESET:
      return {
        ...state,
        vendorPortal: {
          loading: false,
          items: [],
          error: null,
          startedAt: null,
          expectedMs: 45000,
          cancelled: false
        }
      }

    case SEARCH_VENDOR_SITE_REQUEST:
      return { ...state, vendorSite: paginatedRequestState(state.vendorSite, action) }

    case SEARCH_VENDOR_SITE_SUCCESS:
      return { ...state, vendorSite: paginatedSuccessState(state.vendorSite, action) }

    case SEARCH_VENDOR_SITE_FAILURE:
      return { ...state, vendorSite: { loading: false, data: null, error: action.payload } }

    case SEARCH_VENDOR_SITE_RESET:
      return { ...state, vendorSite: { loading: false, data: null, error: null } }

    default:
      return state
  }
}

export default addERPProductReducer
